module.exports = __webpack_public_path__ + "img/mapxxx.1ea44c99.png";